// Static form option constants (content lives in the DB via ContentContext).
export const REQUEST_TYPES = [
  "Booking", "Collaboration", "Interview", "Press / Radio", "Event", "Media Request", "Partnership",
];

export const PLATFORMS = [
  "Spotify", "Apple Music", "Audiomack", "Boomplay", "YouTube", "SoundCloud",
];
